import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f9fafb; /* gray-50 */
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f9fafb; /* gray-50 */
  padding: 24px;
`;

export default function DashboardLayout({ children, title, showStaffPresenceButton = false }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Root>
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <Main $sidebarOpen={sidebarOpen}>
        <TopBar
          title={title}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
          showStaffPresenceButton={showStaffPresenceButton}
        />
        <Content>{children}</Content>
      </Main>
    </Root>
  );
}
